import { logError } from "./util/monitoring/clientUtilsNR";

export default class DependencyLoader {

    private _scriptLoadPromise: Promise<unknown> | null = null;

    whenReady() {
        return this._scriptLoadPromise ? this._scriptLoadPromise.then(() => this) : Promise.reject(this);
    }

    loadScriptDependency(src: string, opt = {}) {
        this._scriptLoadPromise = new Promise((resolve) => {
            window.Spritz.cmd.push(() => {
                resolve(window.Spritz.inject(src, opt));
            });
        }).catch((err) => logError(err));

        return this._scriptLoadPromise;
    }

    destroy() {
        this._scriptLoadPromise = null;
    }

}
